import React from 'react';

class CenteredOverlay extends React.Component {
  render() {
    var classes = this.props.className || '';
    classes += ' b-overlay-centered';
    return (
      <div className={classes} style={this.props.style || {}}>
        <div>{this.props.children}</div>
      </div>
    );
  }
}

export default CenteredOverlay;
